package com.shadowings.gero.domain.usecase

import com.shadowings.gero.domain.model.GameConstants
import com.shadowings.gero.domain.repository.UserDataRepository
import kotlinx.coroutines.flow.first

/**
 * One-time retroactive grant for existing installs: gives a Streak Restoration token for every
 * level already reached before the feature shipped, exactly as if it had been granted on each
 * past level-up. Guarded by `streakRestorationBackfillDone` so it only runs once per install, but
 * `ensureStreakRestorationTokensUpTo` is itself idempotent (put-if-absent per level), so calling
 * this more than once is harmless.
 */
class CheckStreakRestorationBackfillUseCase(
    private val userDataRepository: UserDataRepository,
) {
    suspend operator fun invoke() {
        val userData = userDataRepository.userData.first()
        if (userData.streakRestorationBackfillDone) return
        val currentLevel = GameConstants.getPlayerLevel(userData.experience)
        userDataRepository.ensureStreakRestorationTokensUpTo(currentLevel)
        userDataRepository.setStreakRestorationBackfillDone(true)
    }
}
